import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default function AToolTip({ text, position }) {
	let style = '';

	switch (position) {
		case 'top':
		case 'top-left':
			style = 'a-tool-tip--top-left';
			break;
		case 'top-right':
			style = 'a-tool-tip--top-right';
			break;
		case 'help':
			style = 'a-tool-tip--help';
			break;
		case 'bottom-left':
			style = 'a-tool-tip--bottom-left';
			break;
		case 'bottom-right':
			style = 'a-tool-tip--bottom-right';
			break;
		default:
			style = 'a-tool-tip--bottom-left';
			break;
	}

	return (
		<div className={style}>
			<p>
				<FormattedMessage id={text} defaultMessage="" />
			</p>
		</div>
	);
}

AToolTip.propTypes = {
	position: PropTypes.string,
	text: PropTypes.string,
};

AToolTip.defaultProps = {
	text: '',
	position: 'bottom',
};




// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.tool-tip.js